import 'intersection-observer'
import lozad from 'lozad'
import { getDatasetProperty } from 'MK/DOM/fns/getDatasetProperty'

export const lazyLoad = {
  initialize () {
    console.log('DEBUG (utils.lazyload) Initializing lazy load.')

    // Intersection Observer Polyfill: https://github.com/w3c/IntersectionObserver/tree/gh-pages/polyfill?utm_campaign=chrome_series_intersectionobserverpolyfill_080317&utm_source=chromedev&utm_medium=yt-desc#browser-support
    // To enable polling for all instance, set a value for POLL_INTERVAL on the IntersectionObserver prototype:
    if (IntersectionObserver && IntersectionObserver.prototype) {
      IntersectionObserver.prototype.POLL_INTERVAL = 100 // Time in milliseconds.
    }

    return new lozad('.lazy', {
      rootMargin: '10px 0px', // syntax similar to that of CSS Margin
      threshold: 0, // 0.1 ratio of image convergence
      load: function (el) {
        try {
          el.src = getDatasetProperty(el.dataset, 'original')
        } catch (error) {
          console.log('!!! ERROR (lazyLoad)', error)
          MK.captureException && MK.captureException(error)
        }
      }
    })
  }
}
